export const servicesCategories = [
  {
    id: 1,
    icon: "vlasyStrih",
    header: "Vlasy",
  },
  {
    id: 2,
    icon: "vousyUprava",
    header: "Úprava vousů",
  },

  {
    id: 3,
    icon: "vlasyStrihaVousyUprava",
    header: "Kombinace + káva",
    title: "Kombinace",
  },

  {
    id: 4,
    icon: "fajnsmekr",
    header: "Extravagant",
  },

  {
    id: 5,
    icon: "vlasyStrihVousyHotTowel",
    header: "Přídavky",
    isAdditional: true,
  },
];

export const services = [
  //VLASY
  {
    id: 1,
    categoryId: 1,
    nazev: "Vlasy jednou velikostí",
    cena: { junior: 240, regular: 270, master: 350 },
    delkaTrvani: 15,
  },
  {
    id: 2,
    categoryId: 1,
    nazev: "Klasický střih",
    cena: { junior: 380, regular: 440, master: 590 },
    delkaTrvani: 30,
  },
  {
    id: 3,
    categoryId: 1,
    nazev: "Buzzcut (vršek strojkem, strany skin fade)",
    cena: { junior: 430, regular: 490, master: 630 },
    delkaTrvani: 30,
  },
  {
    id: 4,
    categoryId: 1,
    nazev: "Premium střih (All type fades od 00mm)",
    cena: { junior: 450, regular: 520, master: 650 },
    delkaTrvani: 45,
  },
  {
    id: 5,
    categoryId: 1,
    nazev: "Vlasy dlouhé",
    cena: { junior: 550, regular: 590, master: 690 },
    delkaTrvani: 60,
  },
  {
    id: 39,
    categoryId: 1,
    nazev: "Holení vlasů do hladka",
    cena: { junior: 490, regular: 490, master: 590 },
    delkaTrvani: 30,
  },

  //ÚPRAVA VOUSŮ
  {
    id: 6,
    categoryId: 2,
    nazev: "Vousy krátké",
    cena: { junior: 300, regular: 350, master: 450 },
    delkaTrvani: 30,
  },
  {
    id: 7,
    categoryId: 2,
    nazev: "Vousy dlouhé",
    cena: { junior: 350, regular: 390, master: 490 },
    delkaTrvani: 30,
  },
  {
    id: 8,
    categoryId: 2,
    nazev: "Holení dohladka",
    cena: { junior: 450, regular: 390, master: 490 },
    delkaTrvani: 40,
  },

  //KOMBINACE

  {
    id: 10,
    categoryId: 3,
    nazev: "Střih strojkem (1 velikost) + vousy krátké ",
    cena: { junior: 490, regular: 570, master: 750 },
    delkaTrvani: 45,
  },
  {
    id: 11,
    categoryId: 3,
    nazev: "Střih strojkem (1 velikost) + vousy dlouhé ",
    cena: { junior: 550, regular: 610, master: 690 },
    delkaTrvani: 45,
  },
  {
    id: 22,
    categoryId: 3,
    nazev: "Střih strojkem (1 velikost) + holení vousů do hladka (Facial Steamer)",
    cena: { junior: 640, regular: 610, master: 790},
    delkaTrvani: 55,
  },
  {
    id: 12,
    categoryId: 3,
    nazev: "Klasický střih + vousy krátké ",
    delkaTrvani: 60,
    cena: { junior: 630, regular: 740, master: 990 },
  },
  {
    id: 13,
    categoryId: 3,
    nazev: "Klasický střih + vousy dlouhé ",
    delkaTrvani: 60,
    cena: { junior: 690, regular: 780, master: 1030 },
  },
  {
    id: 23,
    categoryId: 3,
    nazev: "Klasický střih + holení vousů do hladka (Facial Steamer)",
    delkaTrvani: 70,
    cena: { junior: 780, regular: 780, master: 1030 },
  },
  {
    id: 14,
    categoryId: 3,
    nazev: "Premium střih (All type fades od 00mm) + vousy krátké ",
    delkaTrvani: 60,
    cena: { junior: 700, regular: 820, master: 1050 },
  },
  {
    id: 15,
    categoryId: 3,
    nazev: "Premium střih (All type fades od 00mm) + vousy dlouhé ",
    cena: { junior: 810, regular: 860, master: 1070 },
    delkaTrvani: 60,
  },
  {
    id: 26,
    categoryId: 3,
    nazev: "Premium střih (All type fades od 00mm) + holení vousů do hladka (Facial Steamer)",
    cena: { junior: 850, regular: 830, master: 1090 },
    delkaTrvani: 60,
  },
  {
    id: 16,
    categoryId: 3,
    nazev: "Buzzcut + vousy krátké ",
    cena: { junior: 680, regular: 790, master: 1030 },
    delkaTrvani: 60,
  },
  {
    id: 17,
    categoryId: 3,
    nazev: "Buzzcut + vousy dlouhé ",
    cena: { junior: 730, regular: 830, master: 1070 },
    delkaTrvani: 60,
  },
  {
    id: 25,
    categoryId: 3,
    nazev: "Buzzcut + holení vousů do hladka (Facial Steamer)",
    cena: { junior: 830, regular: 830, master: 1070 },
    delkaTrvani: 70,
  },
  {
    id: 18,
    categoryId: 3,
    nazev: "Vlasy dlouhé + vousy krátké ",
    cena: { junior: 800, regular: 890, master: 1090 },
    delkaTrvani: 75,
  },
  {
    id: 19,
    categoryId: 3,
    nazev: "Vlasy dlouhé + vousy dlouhé ",
    cena: { junior: 850, regular: 930, master: 1090 },
    delkaTrvani: 75,
  },
  {
    id: 27,
    categoryId: 3,
    nazev: "Vlasy dlouhé + holení vousů do hladka (Facial Steamer)",
    cena: { junior: 950, regular: 930, master: 1130 },
    delkaTrvani: 75,
  },

  {
    id: 30,
    categoryId: 3,
    nazev: "Holení vlasů do hladka + vousy krátké (Facial Steamer)",
    cena: { junior: 490, regular: 790, master: 990 },
    delkaTrvani: 60,
  },

  {
    id: 31,
    categoryId: 3,
    nazev: "Holení vlasů do hladka + vousy dlouhé (Facial Steamer)",
    cena: { junior: 540, regular: 830, master: 1030},
    delkaTrvani: 70,
  },

  {
    id: 24,
    categoryId: 3,
    nazev: "Holení vlasů do hladka + holení vousů do hladka (Facial Steamer)",
    cena: { junior: 640, regular: 830, master: 1030 },
    delkaTrvani: 75,
  },

  //EXTRAVAGANT
  {
    id: 40,
    categoryId: 4,
    nazev:
      "Masírek",
    description: "Komplexní péče o vlasy a vousy zahrnující střih, holení do hladka (Facial Steamer), masáž hlavy, peeling obličeje, ošetření balzámem po holení, závěrečná úprava vousů, balzám či olej na vousy, styling, kolínská či parfémová voda dle výběru, parafínový zábal rukou, depilace chloupků v nose.",
    cena: { junior: 1700, regular: 1790, master: 2200 },
    delkaTrvani: 90,
  },

  //PŘÍDAVKY
  {
    id: 41,
    categoryId: 5,
    nazev: "Péče o pleť",
    cena: { junior: 900, regular: 900, master: 900 },
    delkaTrvani: 45,
  },
  {
    id: 42,
    categoryId: 5,
    nazev: "Barvení vousů - menší",
    cena: { junior: 230, regular: 230, master: 230 },
    delkaTrvani: 15,
  },
  {
    id: 142,
    categoryId: 5,
    nazev: "Barvení vousů - větší",
    cena: { junior: 290, regular: 290, master: 290 },
    delkaTrvani: 15,
  },
  {
    id: 43,
    categoryId: 5,
    nazev: "Hair Tattoo - menší",
    cena: { junior: 59, regular: 59, master: 59 },
    delkaTrvani: 10,
  },
  {
    id: 143,
    categoryId: 5,
    nazev: "Hair Tattoo - větší",
    cena: { junior: 170, regular: 170, master: 170 },
    delkaTrvani: 20,
  },
  {
    id: 44,
    categoryId: 5,
    nazev: "Černá maska",
    cena: { junior: 100, regular: 100, master: 100 },
    delkaTrvani: 10,
  },
  {
    id: 45,
    categoryId: 5,
    nazev: "Depilace voskem",
    cena: { junior: 69, regular: 69, master: 69 },
    delkaTrvani: 5,
  },
  {
    id: 46,
    categoryId: 5,
    nazev: "Depilace nití",
    cena: { junior: 100, regular: 100, master: 100 },
    delkaTrvani: 5,
  },
  {
    id: 47,
    categoryId: 5,
    nazev: "Mytí hlavy",
    cena: { junior: 59, regular: 59, master: 59 },
    delkaTrvani: 5,
  },
  {
    id: 48,
    categoryId: 5,
    nazev: "Zvýraznění kontur",
    cena: { junior: 39, regular: 39, master: 39 },
    delkaTrvani: 5,
  },
  {
    id: 49,
    categoryId: 5,
    nazev: "Masáž hlavy vlasové tanikum",
    cena: { junior: 69, regular: 69, master: 69 },
    delkaTrvani: 5,
  },

  {
    id: 91,
    categoryId: 5,
    nazev: "Styling",
    cena: { junior: 59, regular: 59, master: 59 },
    delkaTrvani: 5,
  },

  // {
  //   id: 5,
  //   icon: "vousyUprava",
  //   time: "30",
  //   header: "Úpra",
  //   cena: { junior: 300, regular: 300, master: 300 },
  //   text: "Úprava vousů strojkem, ošetření vousů balzámem či olejem na vousy, úprava obočí a kontur, opálení uší, kolínská dle výběru. Nápoje samozřejmostí (Coca Cola, voda, káva, čaj).",
  // },
  // {
  //   id: 5,
  //   icon: "vlasyStrihaVousyUprava",
  //   time: "60",
  //   header: "Střih vlasů + vousy strojkem",
  //   cena: { junior: 700, regular: 700, master: 700 },
  //   text: "Střih vlasů, úprava obočí a kontur, mytí vlasů, opálení uší, styling a kolínská dle výběru. Nápoje samozřejmostí (Coca Cola, voda, káva, čaj).",
  // },
  // {
  //   id: 6,
  //   icon: "vlasyStrihVousyHotTowel",
  //   time: "75",
  //   header: "Střih vlasů + úprava vousů (Hot towel)",
  //   cena: { junior: 900, regular: 900, master: 900 },
  //   text: "Střih vlasů a úprava vousů břitvou (Hot towel + napaření steamerem (holení s párou), zastřižení tvaru vousů strojkem před holením, úprava obočí a kontur, mytí vlasů, opálení uší, balzám před holením, ošetření balzámem po holení, závěrečná úprava vousů, balzám či olej na vousy, styling a kolínská dle výběru. Nápoje samozřejmostí (Coca Cola, voda, káva, čaj).",
  // },
  // {
  //   id: 5,
  //   icon: "fajnsmekr",
  //   time: "90",
  //   header: "Masírek",
  //   cena: { junior: 1490, regular: 1490, master: 1490 },
  //   text: "Úprava vousů břitvou (Hot towel + napaření steamerem (holení s párou), peeling obličeje, ošetření balzámem po holení, závěrečná úprava vousů, balzám či olej na vousy, styling, kolínská či parfémová voda dle výběru, parafínový zábal rukou, depilace chloupků v nose, masáž hlavy. ",
  // },
];

export const visibleGalleryItems = [
  {
    id: 1,
    src: "videoStrih5.MP4",
    video: true,
    extraCSS: "mediumItem",
  },
  {
    id: 2,
    src: "videoStrih1.MP4",
    extraCSS: "bigItem",
    video: true,
  },
  {
    id: 3,
    src: "strih6.webp",
  },
  {
    id: 4,
    src: "strih1.webp",
  },
  {
    id: 7,
    src: "videoStrih3.MP4",
    video: true,
  },
  {
    id: 5,
    src: "strih8.webp",
  },
];

export const hiddenGalleryItems = [
  {
    id: 7,
    src: "strih2.webp",
  },
  {
    id: 10,
    src: "strih17.webp",
  },
  {
    id: 12,
    src: "strih5.webp",
  },
  {
    id: 16,
    src: "videoStrih2.MP4",
    video: true,
    extraCSS: "mediumItem",
  },
  {
    id: 13,
    src: "strih9.webp",
  },

  {
    id: 14,
    src: "strih10.webp",
  },
  {
    id: 15,
    src: "strih13.webp",
  },
  {
    id: 8,
    src: "videoStrih4.MP4",
    video: true,
  },

  {
    id: 16,
    src: "strih14.webp",
  },
  {
    id: 17,
    src: "strih15.webp",
  },
  {
    id: 18,
    src: "strih16.webp",
  },
];
